import { Accordions } from "@/ui/Accordions";
import cn from "classnames";
import { Container } from "react-bootstrap";
import classes from "./styles.module.scss";

export default function ({
  className = "py-5",
  title,
  items,
  prefix,
  EditableText,
  EditableHtml,
  EditableImage,
  theme = "light",
}) {
  return (
    <div className={cn(className, classes.Accordions)} data-bs-theme={theme}>
      <Container>
        <div>
          {title && (
            <EditableText path="title" tag="h2" className="mb-4">
              <span dangerouslySetInnerHTML={{ __html: title }} />
            </EditableText>
          )}
        </div>
        <Accordions
          className="flex-grow-1"
          items={items.map(
            ({ icon, title, content, images, buttons = [], children = null }, idx) => ({
              name: (
                <>
                  {icon && <img src={icon} alt="" />}
                  <EditableText path={`item_${idx}.name`}>
                    <span dangerouslySetInnerHTML={{ __html: title }} />
                  </EditableText>
                </>
              ),
              description: (
                <EditableHtml path={`item_${idx}.description`}>
                  <div dangerouslySetInnerHTML={{ __html: content }} />
                </EditableHtml>
              ),
              images: (images ?? []).map((img, i) => (
                <EditableImage
                  path={`item_${idx}.image_${i}`}
                  className="w-100 h-100 object-fit-cover"
                  src={img}
                  key={i}
                />
              )),
              buttons,
              prefix: `${prefix}.item_${idx}_child`,
              children,
            }),
          )}
        />
      </Container>
    </div>
  );
}
